<div class="container">
  <button
    #menuAnchor
    kendoButton
    class="app-bar__menu"
    [iconClass]="'rc-icon-royal-crown'"
    (click)="toggleMenu()"
  >
  </button>
  <h1 class="app-bar__title">
    <span class="app-bar__title-label">
      CROWNBASE
      <span class="app-bar__title-accent">| NXT</span></span
    >
  </h1>
  <!-- An app can put its search (box or icon) here, next to the user menu -->
  <div class="app-bar__search">
    <ng-content select="[appBarSearch]" />
  </div>
  <rc-user-menu></rc-user-menu>
</div>

@if (menuOpen() && backdrop()) {
  <div class="app-bar__backdrop" (click)="closeMenu()"></div>
}

@if (menuOpen()) {
  <kendo-popup
    [anchor]="menuAnchor"
    [animate]="false"
    [popupClass]="'app-bar-menu-popup'"
    [margin]="{horizontal: 0, vertical: 12}"
    [anchorAlign]="{ horizontal: 'left', vertical: 'bottom' }"
    [popupAlign]="{ horizontal: 'left', vertical: 'top' }"
    [positionMode]="'fixed'"
  >
    <rc-app-menu (close)="closeMenu()"></rc-app-menu>
  </kendo-popup>
}